<template>
  <div class="grid-container sm:justify-center">
    <div
      class="flex flex-col justify-center gap-4 w-full pt-6 md:pt-14 sm:col-span-6 sm:col-start-3 md:col-start-5 lg:col-start-4"
    >
      <h1 class="headline-lg text-center">
        ¡Gracias por registrarte! <br />
        Ahora, verifica tu cuenta
      </h1>
      <p class="title-lg text-center">
        Hemos enviado a tu correo un enlace para verificar tu cuenta. Haz click en ese enlace para
        finalizar tu proceso de registro.
      </p>
      <div class="flex justify-center">
        <Illustration name="mail-sent" width="230" height="206" />
      </div>
      <div class="flex flex-col gap-2 justify-center text-center p-2">
        <p class="title-md">¿No encuentras el correo?</p>
        <p class="title-sm">
          Recuerda buscar en tu buzón de promociones o spam. <br />
          Si no lo encuentras en tu buzón o si el link de validación ha expirado, haz click en el
          siguiente botón para enviarte un nuevo correo electrónico.
        </p>
        <Link
          method="post"
          as="button"
          type="button"
          class="block mx-auto btn-tonal py-2.5 px-6"
          :disabled="this.notificationSent"
          :href="$route('verification.send')"
        >
          {{ this.notificationSent ? 'Reenviado' : 'Reenviar correo' }}
        </Link>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout.vue'
import MailSent from '@/Components/Illustrations/MailSent.vue'
import Illustration from '@/Components/Illustration.vue'

export default {
  layout: Layout,
  components: { MailSent, Link, Illustration },
  props: {
    notificationSent: { type: Boolean, default: false },
  },
  computed: {
    email() {
      return this.$page.props.auth.user.email
    },
  },
}
</script>
